import {Component, Input} from '@angular/core';
import {DocumentStatusHelperPipe} from '../../pages/documents/document-status-helper.pipe';
import {DocumentStatusesEnum} from '../../pages/documents/dto/document-statuses.enum';


@Component({
  selector: 'app-document-status-badge',
  templateUrl: './document-status-badge.component.html',
  styleUrl: './document-status-badge.component.scss',
  providers: [DocumentStatusHelperPipe]
})
export class DocumentStatusBadgeComponent {
    badgeCssClass:string ='';
    status:string='';

    @Input({required:true}) set documentStatus(status: DocumentStatusesEnum | null ){
        this.badgeCssClass =  this.getBadgeCssClass(status);
        this.status =  status || '';
    }

    constructor(private documentStatusHelperPipe:DocumentStatusHelperPipe) {
    }

    private getBadgeCssClass(status: string):string{
        return this.documentStatusHelperPipe.transform((status?.trim() ?? "") as DocumentStatusesEnum );
    }
}
